module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-企业文化核心内容.3115e1e0.png";